import React, { useEffect, useState } from "react";
import axios from "axios";
import Loader from "../../../organisms/loader/Loader";
import { AUDIENCE_GET_ANSWERS } from "../../../endpoints";
import { formatDateDifference } from "../../utils/tools";

// BL-113 — every answer this learner has given, grouped by path, from the
// normalized learner_answers store. A "→ attribute" chip shows when an answer
// was promoted to a personalization attribute.
const fmtAnswer = (a) => {
  if (Array.isArray(a)) return a.join(", ");
  if (typeof a === "boolean") return a ? "Yes" : "No";
  return a ?? "";
};

function AnswersTab({ audienceId, token }) {
  const [groups, setGroups] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let alive = true;
    setLoading(true);
    axios
      .get(AUDIENCE_GET_ANSWERS(audienceId), { headers: { Authorization: token } })
      .then(({ data }) => { if (alive) setGroups(data.records || []); })
      .catch(() => {})
      .finally(() => { if (alive) setLoading(false); });
    return () => { alive = false; };
  }, [audienceId, token]);

  if (loading) return <div className="lp-pad"><Loader /></div>;

  const total = groups.reduce((n, g) => n + (g.answers?.length || 0), 0);
  if (total === 0) {
    return <div className="lp-pad"><div className="lp-empty-inline">No answers captured yet.</div></div>;
  }

  return (
    <div className="lp-pad">
      {groups.map((g) => (
        <div className="lp-ansgrp" key={g.learning_material_id}>
          <div className="lp-ansgrp__h">{g.learning_material_name}</div>
          {(g.answers || []).map((a, i) => (
            // eslint-disable-next-line react/no-array-index-key
            <div className="lp-qa" key={i}>
              <div className="lp-qa__q">
                <b>{a.question || "Question"}</b>
                {a.saved_to_attribute && <span className="lp-ansgrp__map">→ {a.saved_to_attribute}</span>}
                <span className="lp-qa__tm">{formatDateDifference(a.submitted_at)}</span>
              </div>
              <div className="lp-qa__a">{fmtAnswer(a.answer)}</div>
            </div>
          ))}
        </div>
      ))}
    </div>
  );
}

export default AnswersTab;
